import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxUploaderModule } from 'ngx-uploader';

import { FileManagerComponent } from './file-manager.component';
//import { FileManagerUploadComponent } from './file-manager-upload/file-manager-upload.component';
//import { FileManagerViewComponent } from './file-manager-view/file-manager-view.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FileManagerViewModule } from './file-manager-view/file-manager-view.module';
import { FormsTDOModule } from '../forms/froms.module';


//import { FileManagerImageComponent } from './file-manager-view/file-manager-image/file-manager-image.component';
//import { FileManagerContextComponent } from './file-manager-view/file-manager-context/file-manager-context.component';


@NgModule({
    declarations: [
        FileManagerComponent,
        //FileManagerUploadComponent,
        //FileManagerViewComponent,
        //FileManagerImageComponent,
        //FileManagerContextComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgxUploaderModule,
        DragDropModule,
        FormsTDOModule,
        FileManagerViewModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSliderModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatDialogModule,
        MatSnackBarModule,
        MatProgressBarModule,
    ],
    exports: [
        FileManagerComponent
    ]
})
export class FileManagerModule { }
